import { ExternArbetsorderStatus } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IDestineringsRad } from "./IExternArbetsorderDetails";

export class DestineringsRadViewModel {
    constructor(private readonly model: IDestineringsRad) {
    }

    get inmatningshandelssortiment(): string {
        return this.model.inmatningshandelssortiment;
    }

    get produceratHandelssortiment(): string {
        return this.model.produceratHandelssortiment;
    }

    get handelssortiment(): string {
        return this.model.externdestineringskoppling?.handelssortiment;
    }

    get mottagningsplats(): string {
        if(!ObjectUtils.isNullOrUndefined(this.model.mottagningsplatsnamn)) {
            return `${this.model.mottagningsplatsnummer} ${this.model.mottagningsplatsnamn}`;
        }
        return this.model.mottagningsplatsnummer;
    }

    get giltigFrom(): Date {
        return this.model.giltigFrom;
    }

    get giltigTom(): Date {
        return this.model.giltigTom;
    }

    get felmeddelande(): string {
        return this.model.externdestineringskoppling?.felmeddelande;
    }

    get status(): string {
        return this.model.externdestineringskoppling?.status;
    }

    get externDestineringskopplingId(): number {
        return this.model.externdestineringskoppling?.externDestineringskopplingId;
    }

    get radnummer(): string {
        return this.model.radnummer;
    }

    get sste(): string {
        return this.model.sste;
    }

    get mma(): string {
        return this.model.mma;
    }

    get mmb(): string {
        return this.model.mmb;
    }

    get kollektiv(): string {
        return this.model.kollektiv;
    }

    get mmc(): string {
        return this.model.mmc;
    }

    get mmd(): string {
        return this.model.mmd;
    }

    get voStatusRad(): string {
        return this.model.voStatusRad;
    }

    get checked(): boolean {
        return this.status === ExternArbetsorderStatus.Ignorerad;
    }

    set checked(value: boolean) {
        // för att undvika console fel, vid onmodelchange togglas status baserat på denna checkbox
    }
}
